import dayjs from "dayjs";

export const MEXICO_TIMEZONE = "America/Mexico_City";

export const getMexicoNow = () => dayjs().tz(MEXICO_TIMEZONE);

export const toMexicoTime = (value) => dayjs(value).tz(MEXICO_TIMEZONE);

export const getMexicoDateTime = (date, time = "00:00") =>
  dayjs.tz(`${date} ${time}`, "YYYY-MM-DD HH:mm", MEXICO_TIMEZONE);
